export default function formatFileSize(fileSize = 1024 * 1024) {
  if (fileSize >= Math.pow(1024, 5)) {
    return parseInt((fileSize / Math.pow(1024, 5)) * 100, 10) / 100 + 'EB';
  }
  if (fileSize >= Math.pow(1024, 4)) {
    return parseInt((fileSize / Math.pow(1024, 4)) * 100, 10) / 100 + 'PB';
  }
  if (fileSize >= Math.pow(1024, 3)) {
    return parseInt((fileSize / Math.pow(1024, 3)) * 100, 10) / 100 + 'GB';
  }
  if (fileSize >= Math.pow(1024, 2)) {
    return parseInt((fileSize / Math.pow(1024, 2)) * 100, 10) / 100 + 'MB';
  }
  if (fileSize >= Math.pow(1024, 1)) {
    return parseInt((fileSize / Math.pow(1024, 2)) * 100, 10) / 100 + 'KB';
  }
  return fileSize + 'B';
}
